// extracted by mini-css-extract-plugin
export default {"header":"KRAScreen_header__hj1L+","container":"KRAScreen_container__vEEiR"};